import {flatten} from "@/helper/characteristic/Flatten";
import _ from "lodash";
import {byId} from "@/helper/application/characteristic/Provider";

export const TYPE__FUNCTION__ORGANISATIONAL_AREA = 'function--organisational-area';
export const TYPE__SUPPRESS_FOR_SCHOOL_TYPE = 'suppress-for-school-type';

export function removeItemsWithCorrelation ({items, target, type})
{
	const shouldSuppress = function (characteristic)
	{
		let suppress = false;

		let correlations = characteristic.correlations.filter(c => c.type === type);

		if (correlations.length > 0)
		{
			correlations.forEach(correlation =>
			{
				if (correlation.target.id === target.id)
				{
					suppress = true;
					return false; // break
				}
			});
		}

		return suppress;
	}

	const check = function (characteristic)
	{
		let newChildren = [];

		characteristic.children.forEach(child =>
		{
			child = check(child);

			if (!shouldSuppress(child))
			{
				newChildren.push(child);
			}
		});

		characteristic.children = newChildren;

		return characteristic;
	};

	let newItems = [];

	items.forEach(characteristic =>
	{
		if (!shouldSuppress(characteristic))
		{
			newItems.push(
				check(characteristic)
			);
		}
	});

	return newItems;
}

export function cleanUp ({selected, characteristicItems})
{
	if (!selected)
	{
		return selected;
	}

	const validIds = flatten(characteristicItems).map(c => c.id);

	selected = selected.filter(item =>
	{
		return validIds.includes(item.item.id);
	});

	const professionIds = selected.map(item => item.item.id);

	// remove all stale parents
	selected = selected.filter(item =>
	{
		const childIds = item.item.children.map(c => c.id);

		return childIds.length === 0 || _.intersection(professionIds, childIds).length > 0;
	});

	if (selected.length === 0)
	{
		selected = undefined;
	}
	else
	{
		// reload characteristic, otherwise there could be some children missing
		selected.forEach((item, i) =>
		{
			selected[i].item = byId(item.item.id, characteristicItems);
		});
	}

	return selected;
}
